import PropTypes from 'prop-types';
import { useState, useEffect } from 'react';
import classes from './yesNoToggle.module.css';

const YesNoToggle = ({
  label,
  value,
  onChange,
  disabled = false,
  required = false,
  name,
  error,
  yesColor = '#4CAF50',
  noColor = '#E91E63',
  boldLabel = false,
}) => {
  const [selectedValue, setSelectedValue] = useState(value || '');

  useEffect(() => {
    setSelectedValue(value);
  }, [value]);

  const handleChange = (newValue) => {
    if (disabled) return;
    setSelectedValue(newValue);
    if (onChange) {
      onChange(newValue);
    }
  };

  return (
    <div className={classes.toggleWrapper}>
      <div className={classes.labelSection}>
        {label && (
          <label className={`${classes.toggleLabel} ${boldLabel ? classes.boldLabel : ''}`}>
            {label}
            {required && <span className={classes.required}> *</span>}
          </label>
        )}
        {error && (
          <div className={classes.errorMessage}>
            {error}
          </div>
        )}
      </div>
      <div className={classes.toggleContainer} role="radiogroup" aria-label={label}>
        <label className={`${classes.toggleSegment} ${classes.noSegment} ${selectedValue === 'no' ? classes.selected : classes.unselected}`}
          style={{
            '--active-color': noColor,
            '--inactive-color': 'var(--mantine-color-gray-5)',
          }}
        >
          <input
            type="radio"
            name={name}
            value="no"
            checked={selectedValue === 'no'}
            onChange={() => handleChange('no')}
            disabled={disabled}
            className={classes.radioInput}
          />
          <span className={classes.toggleIcon}>✕</span>
          <span className={classes.toggleText}>לא</span>
        </label>

        <label className={`${classes.toggleSegment} ${classes.yesSegment} ${selectedValue === 'yes' ? classes.selected : classes.unselected}`}
          style={{
            '--active-color': yesColor,
            '--inactive-color': 'var(--mantine-color-gray-5)',
          }}
        >
          <input
            type="radio"
            name={name}
            value="yes"
            checked={selectedValue === 'yes'}
            onChange={() => handleChange('yes')}
            disabled={disabled}
            className={classes.radioInput}
          />
          <span className={classes.toggleIcon}>✓</span>
          <span className={classes.toggleText}>כן</span>
        </label>
      </div>
    </div>
  );
};

YesNoToggle.propTypes = {
  label: PropTypes.string,
  value: PropTypes.oneOf(['yes', 'no']),
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  required: PropTypes.bool,
  name: PropTypes.string.isRequired,
  error: PropTypes.string,
  yesColor: PropTypes.string,
  noColor: PropTypes.string,
  boldLabel: PropTypes.bool,
};

export default YesNoToggle;
